import { ApiResponse, Invoice } from '../../types';
import apiClient from '../api/client';

interface InvoiceListResponse {
  success: boolean;
  data: Invoice[];
  meta: {
    page: number;
    pageSize: number;
    count: number;
    next: string | null;
    previous: string | null;
  };
}

export const invoiceService = {
  getList: async (filters?: {
    invoiceNumber?: string;
    patientName?: string;
    service?: string;
    startDate?: string;
    endDate?: string;
    page?: number;
    pageSize?: number;
  }): Promise<InvoiceListResponse> => {
    const params: Record<string, any> = {};
    
    if (filters?.invoiceNumber) {
      params.invoice_number = filters.invoiceNumber;
    }
    if (filters?.patientName) {
      params.customer_name = filters.patientName;
    }
    if (filters?.service) {
      params.service_name = filters.service;
    }
    if (filters?.startDate) {
      params.start_date = filters.startDate;
    }
    if (filters?.endDate) {
      params.end_date = filters.endDate;
    }
    if (filters?.page) {
      params.page = filters.page;
    }
    if (filters?.pageSize) {
      params.page_size = filters.pageSize;
    }

    const response = await apiClient.get<InvoiceListResponse>('/invoices/', { params });
    return response.data;
  },

  getDetail: async (id: number): Promise<ApiResponse<Invoice>> => {
    const response = await apiClient.get<ApiResponse<Invoice>>(`/invoices/${id}/`);
    return response.data;
  },
};

